import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class MotivosServices {
  getMotivos = params =>
    AxiosClient.get("/api/app/seleccion_contratacion_motivo/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getMotivo = id =>
    AxiosClient.get(`/api/app/seleccion_contratacion_motivo/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveMotivo = data =>
    AxiosClient.post("/api/app/seleccion_contratacion_motivo/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editMotivos = (id, data) =>
    AxiosClient.put(
      `/api/app/seleccion_contratacion_motivo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteMotivo = id =>
    AxiosClient.delete(`/api/app/seleccion_contratacion_motivo/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new MotivosServices();